"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1AdminEligibilityPartnersGetIntegrationTypeEnum = exports.V1AdminCacheAiRouterCacheKeyDeleteCacheKeyEnum = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * AdminApi - axios parameter creator
 */
const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Free form user account lookup. Lookup by first, last name, email, phone number, or friends & family invitation code.
         * @param {string} [q] Search term for given name, family name, email, phone number, or friends &amp; family invitation code. It should have 3 or more characters to get result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAccountsGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ q }, options = {}) {
            const localVarPath = `/v1/admin/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/accounts`,
                sdkMethod: 'v1AdminAccountsGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Clears cached Databricks responses for the specified AI Router endpoint. This endpoint allows administrators to manually clear cached responses to ensure the next request fetches the most up-to-date data from Databricks.  Supported cache keys: - echo_back: Clears all cache entries with the pattern \"{databricks_echo_back}_*\" - content_filter: Clears all cache entries with the pattern \"{databricks_content_filter}_*\"
         * @summary Clears AI Router cached responses from Databricks.
         * @param {V1AdminCacheAiRouterCacheKeyDeleteCacheKeyEnum} cacheKey Cache key (echo_back or content_filter)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheAiRouterCacheKeyDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ cacheKey }, options = {}) {
            // verify required parameter 'cacheKey' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheAiRouterCacheKeyDelete', 'cacheKey', cacheKey);
            const localVarPath = `/v1/admin/cache/ai-router/{cache_key}`.replace('{cache_key}', encodeURIComponent(String(cacheKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/ai-router/{cache_key}`,
                sdkMethod: 'v1AdminCacheAiRouterCacheKeyDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/admin/cache/b2b`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b`,
                sdkMethod: 'v1AdminCacheB2bDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Enumerates child partners of the given parent via the B2B service and invalidates every B2B cache entry (partner_pp, partner_slug_pp, partner_client_id_pp, sponsorship_pp, referral_pp, partner_health_resources_pp) belonging to those children. Intended for bulk flows like the CH EWS file ingestion process so callers don\'t have to issue a per-partner delete for every child.
         * @summary Clears B2B cache for every child partner of the given parent.
         * @param {string} parentPartnerId Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bParentsParentPartnerIdPartnersDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ parentPartnerId, }, options = {}) {
            // verify required parameter 'parentPartnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bParentsParentPartnerIdPartnersDelete', 'parentPartnerId', parentPartnerId);
            const localVarPath = `/v1/admin/cache/b2b/parents/{parent_partner_id}/partners`.replace('{parent_partner_id}', encodeURIComponent(String(parentPartnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b/parents/{parent_partner_id}/partners`,
                sdkMethod: 'v1AdminCacheB2bParentsParentPartnerIdPartnersDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin API request handler.
         * @summary Deletes partner resources from cache for given identifiers.
         * @param {string} partnerId Partner ID
         * @param {string} [partnerSlug] Partner Slug
         * @param {string} [parentPartnerId] Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, partnerSlug, parentPartnerId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bPartnersPartnerIdDelete', 'partnerId', partnerId);
            const localVarPath = `/v1/admin/cache/b2b/partners/{partner_id}`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (partnerSlug !== undefined) {
                localVarQueryParameter['partner_slug'] = partnerSlug;
            }
            if (parentPartnerId !== undefined) {
                localVarQueryParameter['parent_partner_id'] = parentPartnerId;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b/partners/{partner_id}`,
                sdkMethod: 'v1AdminCacheB2bPartnersPartnerIdDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {string} partnerId Partner ID
         * @param {string} [isDependentGroup] Is dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, isDependentGroup, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete', 'partnerId', partnerId);
            const localVarPath = `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (isDependentGroup !== undefined) {
                localVarQueryParameter['is_dependent_group'] = isDependentGroup;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships`,
                sdkMethod: 'v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Clears data cached in the referrals key for the specified partner id and sponsorship id. Clears data for all supported languages.
         * @summary Clears cached referral data.
         * @param {string} partnerId Partner ID
         * @param {string} sponsorshipId Sponsorship ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, sponsorshipId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete', 'partnerId', partnerId);
            // verify required parameter 'sponsorshipId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete', 'sponsorshipId', sponsorshipId);
            const localVarPath = `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships/{sponsorship_id}/referrals`
                .replace('{partner_id}', encodeURIComponent(String(partnerId)))
                .replace('{sponsorship_id}', encodeURIComponent(String(sponsorshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers
                ? baseOptions.headers
                : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships/{sponsorship_id}/referrals`,
                sdkMethod: 'v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Admin Create Rewards creates rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Create Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCreateRewards: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rewardAdminRewardsRequest }, options = {}) {
            const localVarPath = `/v1/rewards/admin/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/rewards`,
                sdkMethod: 'v1AdminCreateRewards',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rewardAdminRewardsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Admin Delete Recipient Reward deletes a specific reward for a recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Delete Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} rewardId The ID of the reward
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminDeleteRecipientReward: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, rewardId }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminDeleteRecipientReward', 'recipientId', recipientId);
            // verify required parameter 'rewardId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminDeleteRecipientReward', 'rewardId', rewardId);
            const localVarPath = `/v1/rewards/admin/recipients/{recipient_id}/rewards/{reward_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{reward_id}', encodeURIComponent(String(rewardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/recipients/{recipient_id}/rewards/{reward_id}`,
                sdkMethod: 'v1AdminDeleteRecipientReward',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns Calm Health partner configs
         * @param {V1AdminEligibilityPartnersGetIntegrationTypeEnum} [integrationType] Filter by integration type
         * @param {boolean} [active] Filter by active status (server default is true)
         * @param {string} [sort] Sort field (server default is \&quot;name\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminEligibilityPartnersGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ integrationType, active, sort, }, options = {}) {
            const localVarPath = `/v1/admin/eligibility-partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (integrationType !== undefined) {
                localVarQueryParameter['integration_type'] = integrationType;
            }
            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/eligibility-partners`,
                sdkMethod: 'v1AdminEligibilityPartnersGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves the full partner configuration by looking up a child partner using parent partner ID and client IDs.
         * @summary Get partner configuration by client IDs
         * @param {string} parentPartnerId Parent partner ID
         * @param {string} clientId Client ID from health config
         * @param {string} fallbackClientId Fallback client ID from health config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersConfigByClientIdsGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ parentPartnerId, clientId, fallbackClientId, }, options = {}) {
            // verify required parameter 'parentPartnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersConfigByClientIdsGet', 'parentPartnerId', parentPartnerId);
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersConfigByClientIdsGet', 'clientId', clientId);
            // verify required parameter 'fallbackClientId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersConfigByClientIdsGet', 'fallbackClientId', fallbackClientId);
            const localVarPath = `/v1/admin/partners/config/by-client-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (parentPartnerId !== undefined) {
                localVarQueryParameter['parent_partner_id'] = parentPartnerId;
            }
            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }
            if (fallbackClientId !== undefined) {
                localVarQueryParameter['fallback_client_id'] = fallbackClientId;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/partners/config/by-client-ids`,
                sdkMethod: 'v1AdminPartnersConfigByClientIdsGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves the full partner configuration including health config for the specified partner slug.
         * @summary Get partner configuration by slug
         * @param {string} slug Partner slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersConfigBySlugGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ slug }, options = {}) {
            // verify required parameter 'slug' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersConfigBySlugGet', 'slug', slug);
            const localVarPath = `/v1/admin/partners/config/by-slug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/partners/config/by-slug`,
                sdkMethod: 'v1AdminPartnersConfigBySlugGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves the full partner configuration including health config for the specified partner ID.
         * @summary Get partner configuration by ID
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdConfigGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersPartnerIdConfigGet', 'partnerId', partnerId);
            const localVarPath = `/v1/admin/partners/{partner_id}/config`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/partners/{partner_id}/config`,
                sdkMethod: 'v1AdminPartnersPartnerIdConfigGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Issues an activation link, valid for 24 hours, for an eligibility record stored under `partner_id` that has no active sponsorship. A record whose sponsorship was removed can be issued a new link. When the record\'s client id or fallback client id matches a child partner of `partner_id`, the link names the child and carries `partner_id` as its parent partner; otherwise it names `partner_id` alone. Buy-up partners are refused: a buy-up child, or a partner with a pending upgrade transition. Requires write permission.
         * @summary Generate an activation link for an existing eligibility record
         * @param {string} partnerId The partner the eligibility record is stored under.
         * @param {string} memberId The eligibility record\&#39;s own id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, memberId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost', 'partnerId', partnerId);
            // verify required parameter 'memberId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost', 'memberId', memberId);
            const localVarPath = `/v1/admin/partners/{partner_id}/eligibility/members/{member_id}/activation-link`
                .replace('{partner_id}', encodeURIComponent(String(partnerId)))
                .replace('{member_id}', encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers
                ? baseOptions.headers
                : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/partners/{partner_id}/eligibility/members/{member_id}/activation-link`,
                sdkMethod: 'v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Eligibility Search Admin API handler that fuzzy searches members on a partner\'s eligibility list.
         * @summary Eligibility Search Admin API handler
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersSearchGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, memberId, email, firstName, lastName, dob, subscriberId, partnerMemberId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersPartnerIdEligibilityMembersSearchGet', 'partnerId', partnerId);
            const localVarPath = `/v1/admin/partners/{partner_id}/eligibility/members/search`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }
            if (dob !== undefined) {
                localVarQueryParameter['dob'] =
                    dob instanceof Date
                        ? dob.toISOString().substring(0, 10)
                        : dob;
            }
            if (subscriberId !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriberId;
            }
            if (partnerMemberId !== undefined) {
                localVarQueryParameter['partner_member_id'] = partnerMemberId;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/partners/{partner_id}/eligibility/members/search`,
                sdkMethod: 'v1AdminPartnersPartnerIdEligibilityMembersSearchGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the partner\'s sponsorship (group) configurations, each with its access code (sponsor code, derived from the group\'s segment match criteria). Used by the admin UI to let an operator pick a group when assigning a sponsorship; the chosen access code is sent as the sponsor_code field to the circle assign endpoint. Groups with no access code (default match-all sponsorships) return an empty accessCode.
         * @summary List a partner\'s sponsorship (group) configurations
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdSponsorshipsGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersPartnerIdSponsorshipsGet', 'partnerId', partnerId);
            const localVarPath = `/v1/admin/partners/{partner_id}/sponsorships`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/partners/{partner_id}/sponsorships`,
                sdkMethod: 'v1AdminPartnersPartnerIdSponsorshipsGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRecipientRecipientIdGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminRecipientRecipientIdGet', 'recipientId', recipientId);
            const localVarPath = `/v1/admin/recipient/{recipient_id}`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/recipient/{recipient_id}`,
                sdkMethod: 'v1AdminRecipientRecipientIdGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves all keys from Redis cache and returns detailed timing statistics. Returns the list of keys, count, timing information, and response body size metrics for monitoring and debugging purposes.
         * @summary Retrieve all keys from Redis cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRedisKeysGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/admin/redis/keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/redis/keys`,
                sdkMethod: 'v1AdminRedisKeysGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a value from Redis cache using the provided key and returns detailed timing statistics. Returns the value, timing information, and response body size metrics for monitoring and debugging purposes.
         * @summary Retrieve value from Redis cache by key
         * @param {string} key Redis key to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRedisKeysKeyGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ key }, options = {}) {
            // verify required parameter 'key' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminRedisKeysKeyGet', 'key', key);
            const localVarPath = `/v1/admin/redis/keys/{key}`.replace('{key}', encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/redis/keys/{key}`,
                sdkMethod: 'v1AdminRedisKeysKeyGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Admin Remove Rewards removes rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Remove Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRemoveRewards: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rewardAdminRewardsRequest }, options = {}) {
            const localVarPath = `/v1/rewards/admin/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/rewards`,
                sdkMethod: 'v1AdminRemoveRewards',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rewardAdminRewardsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns user sponsor, dependents, and parents.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminUsersUserIdGet', 'userId', userId);
            const localVarPath = `/v1/admin/users/{user_id}`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/users/{user_id}`,
                sdkMethod: 'v1AdminUsersUserIdGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns timestamp when user active tokens got blocked.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminUsersUserIdTokensBlockedGet', 'userId', userId);
            const localVarPath = `/v1/admin/users/{user_id}/tokens/blocked`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/users/{user_id}/tokens/blocked`,
                sdkMethod: 'v1AdminUsersUserIdTokensBlockedGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidates active access tokens of the user specified by user_id parameter.
         * @summary Blocks user active tokens
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedPost: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminUsersUserIdTokensBlockedPost', 'userId', userId);
            const localVarPath = `/v1/admin/users/{user_id}/tokens/blocked`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/users/{user_id}/tokens/blocked`,
                sdkMethod: 'v1AdminUsersUserIdTokensBlockedPost',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Admin Recipient Rewards returns all rewards for a specific recipient including soft-deleted rewards.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Recipient Rewards (Admin Only)
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRecipientRewards: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, limit, offset }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetAdminRecipientRewards', 'recipientId', recipientId);
            const localVarPath = `/v1/rewards/admin/recipients/{recipient_id}/rewards`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/recipients/{recipient_id}/rewards`,
                sdkMethod: 'v1GetAdminRecipientRewards',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Admin Rewards returns a list of rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Rewards (Admin Only)
         * @param {Array<string>} [affiliatePartner] Partner IDs to filter rewards for
         * @param {boolean} [includeRedeemed] Include redeemed rewards in the response
         * @param {boolean} [includeDeleted] Include deleted rewards in the response
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRewards: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ affiliatePartner, includeRedeemed, includeDeleted, limit, offset, }, options = {}) {
            const localVarPath = `/v1/rewards/admin/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (affiliatePartner) {
                localVarQueryParameter['affiliatePartner'] = affiliatePartner;
            }
            if (includeRedeemed !== undefined) {
                localVarQueryParameter['includeRedeemed'] = includeRedeemed;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/rewards`,
                sdkMethod: 'v1GetAdminRewards',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Clinical Programs Access returns a complete access matrix showing all clinical programs and which lines of business (LOBs) have access to them. This endpoint provides both business-friendly LOB names (e.g., \"Optum\", \"E&I/UnitedHealth Group\") and technical partner ID details for debugging.  This is useful for understanding the full scope of workflow access across all LOBs and validating that partner restriction configurations are correct.  **Admin Access Required**: This endpoint requires admin permissions and is intended for internal use.  |Feature|Permission| |-------|----------| | access | admin |
         * @summary v1 Get Clinical Programs Access Matrix (Admin Only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetClinicalProgramsAccess: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/workflows/admin/clinical-programs-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/admin/clinical-programs-access`,
                sdkMethod: 'v1GetClinicalProgramsAccess',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Partner Child User Counts returns the number of distinct active users per child partner for a given parent partner. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Child User Counts (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerChildUserCounts: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerChildUserCounts', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}/children/users/count`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/children/users/count`,
                sdkMethod: 'v1GetPartnerChildUserCounts',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Partner User Count returns the number of distinct users for a partner within a date range. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner User Count (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUserCount: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, startDate, endDate }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUserCount', 'partnerId', partnerId);
            // verify required parameter 'startDate' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUserCount', 'startDate', startDate);
            // verify required parameter 'endDate' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUserCount', 'endDate', endDate);
            const localVarPath = `/v1/partners/{partner_id}/users/count`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] =
                    startDate instanceof Date
                        ? startDate.toISOString()
                        : startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] =
                    endDate instanceof Date
                        ? endDate.toISOString()
                        : endDate;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/users/count`,
                sdkMethod: 'v1GetPartnerUserCount',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Partner Users returns a paginated list of user accounts for a partner whose sponsorship_start_date falls within the given date range. Accounts are hydrated from the identity service. This endpoint is for internal admin use only.  Results are ordered by sponsorship `created_at DESC, user_id ASC` when `is_suspicious` is omitted (pagination driven by circle). When `is_suspicious` is supplied, the filter, pagination, and ordering are applied by identity over the full partner+date user_id set; ordering in that case is by account `created_at DESC, user_id ASC`.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Users (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {boolean} [isSuspicious] Optional filter on the &#x60;is_suspicious&#x60; flag. Omit to skip the filter; pass &#x60;true&#x60; to return only suspicious users; pass &#x60;false&#x60; to return only non-suspicious users.
         * @param {number} [limit] Max accounts to return per page. Defaults to 50, capped at 200.
         * @param {number} [offset] Number of accounts to skip. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUsers: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, startDate, endDate, isSuspicious, limit, offset, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUsers', 'partnerId', partnerId);
            // verify required parameter 'startDate' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUsers', 'startDate', startDate);
            // verify required parameter 'endDate' is not null or undefined
            (0, common_1.assertParamExists)('v1GetPartnerUsers', 'endDate', endDate);
            const localVarPath = `/v1/partners/{partner_id}/users`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] =
                    startDate instanceof Date
                        ? startDate.toISOString()
                        : startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] =
                    endDate instanceof Date
                        ? endDate.toISOString()
                        : endDate;
            }
            if (isSuspicious !== undefined) {
                localVarQueryParameter['is_suspicious'] = isSuspicious;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/users`,
                sdkMethod: 'v1GetPartnerUsers',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Mark Partner Users Suspicious marks users for a partner whose sponsorship was created within a date range as suspicious or not suspicious. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Mark Partner Users Suspicious (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {CircleMarkPartnerUsersSuspiciousRequest} circleMarkPartnerUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MarkPartnerUsersSuspicious: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, circleMarkPartnerUsersSuspiciousRequest, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1MarkPartnerUsersSuspicious', 'partnerId', partnerId);
            // verify required parameter 'circleMarkPartnerUsersSuspiciousRequest' is not null or undefined
            (0, common_1.assertParamExists)('v1MarkPartnerUsersSuspicious', 'circleMarkPartnerUsersSuspiciousRequest', circleMarkPartnerUsersSuspiciousRequest);
            const localVarPath = `/v1/partners/{partner_id}/users/suspicious`.replace('{partner_id}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/partners/{partner_id}/users/suspicious`,
                sdkMethod: 'v1MarkPartnerUsersSuspicious',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleMarkPartnerUsersSuspiciousRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Test Workflow Restrictions is an admin-only endpoint that simulates what workflows would be accessible for a theoretical recipient with the given partner and global classifier parameters. This endpoint is useful for testing and debugging partner workflow restrictions configuration changes.  The endpoint returns detailed information about which workflows are allowed or restricted, and why each restriction is applied, enabling administrators to validate configuration changes before deploying them.  **Admin Access Required**: This endpoint requires admin permissions and is intended for internal testing only.  |Feature|Permission| |-------|----------| | access | admin |
         * @summary v1 Test Workflow Restrictions (Admin Only)
         * @param {string} [partnerId] Partner ID to test restrictions for
         * @param {string} [parentPartnerId] Parent Partner ID to test restrictions for
         * @param {string} [sponsorshipId] Sponsorship ID to test restrictions for
         * @param {string} [globalClassifier] Global classifier to test restrictions for (e.g., us, gb, us_under_18)
         * @param {string} [workflowType] Filter results to specific workflow type (e.g., clinical_program, user_registration, survey)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TestWorkflowRestrictions: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, parentPartnerId, sponsorshipId, globalClassifier, workflowType, }, options = {}) {
            const localVarPath = `/v1/workflows/admin/test-restrictions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (partnerId !== undefined) {
                localVarQueryParameter['partner_id'] = partnerId;
            }
            if (parentPartnerId !== undefined) {
                localVarQueryParameter['parent_partner_id'] = parentPartnerId;
            }
            if (sponsorshipId !== undefined) {
                localVarQueryParameter['sponsorship_id'] = sponsorshipId;
            }
            if (globalClassifier !== undefined) {
                localVarQueryParameter['global_classifier'] = globalClassifier;
            }
            if (workflowType !== undefined) {
                localVarQueryParameter['workflow_type'] = workflowType;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/workflows/admin/test-restrictions`,
                sdkMethod: 'v1TestWorkflowRestrictions',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 */
const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Free form user account lookup. Lookup by first, last name, email, phone number, or friends & family invitation code.
         * @param {string} [q] Search term for given name, family name, email, phone number, or friends &amp; family invitation code. It should have 3 or more characters to get result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAccountsGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminAccountsGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminAccountsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Clears cached Databricks responses for the specified AI Router endpoint. This endpoint allows administrators to manually clear cached responses to ensure the next request fetches the most up-to-date data from Databricks.  Supported cache keys: - echo_back: Clears all cache entries with the pattern \"{databricks_echo_back}_*\" - content_filter: Clears all cache entries with the pattern \"{databricks_content_filter}_*\"
         * @summary Clears AI Router cached responses from Databricks.
         * @param {V1AdminCacheAiRouterCacheKeyDeleteCacheKeyEnum} cacheKey Cache key (echo_back or content_filter)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheAiRouterCacheKeyDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheAiRouterCacheKeyDelete(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminCacheAiRouterCacheKeyDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bDelete(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminCacheB2bDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Enumerates child partners of the given parent via the B2B service and invalidates every B2B cache entry (partner_pp, partner_slug_pp, partner_client_id_pp, sponsorship_pp, referral_pp, partner_health_resources_pp) belonging to those children. Intended for bulk flows like the CH EWS file ingestion process so callers don\'t have to issue a per-partner delete for every child.
         * @summary Clears B2B cache for every child partner of the given parent.
         * @param {string} parentPartnerId Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bParentsParentPartnerIdPartnersDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bParentsParentPartnerIdPartnersDelete(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminCacheB2bParentsParentPartnerIdPartnersDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Admin API request handler.
         * @summary Deletes partner resources from cache for given identifiers.
         * @param {string} partnerId Partner ID
         * @param {string} [partnerSlug] Partner Slug
         * @param {string} [parentPartnerId] Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bPartnersPartnerIdDelete(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminCacheB2bPartnersPartnerIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {string} partnerId Partner ID
         * @param {string} [isDependentGroup] Is dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Clears data cached in the referrals key for the specified partner id and sponsorship id. Clears data for all supported languages.
         * @summary Clears cached referral data.
         * @param {string} partnerId Partner ID
         * @param {string} sponsorshipId Sponsorship ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Admin Create Rewards creates rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Create Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCreateRewards(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCreateRewards(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminCreateRewards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Admin Delete Recipient Reward deletes a specific reward for a recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Delete Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} rewardId The ID of the reward
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminDeleteRecipientReward(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminDeleteRecipientReward(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminDeleteRecipientReward']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Returns Calm Health partner configs
         * @param {V1AdminEligibilityPartnersGetIntegrationTypeEnum} [integrationType] Filter by integration type
         * @param {boolean} [active] Filter by active status (server default is true)
         * @param {string} [sort] Sort field (server default is \&quot;name\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminEligibilityPartnersGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminEligibilityPartnersGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminEligibilityPartnersGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves the full partner configuration by looking up a child partner using parent partner ID and client IDs.
         * @summary Get partner configuration by client IDs
         * @param {string} parentPartnerId Parent partner ID
         * @param {string} clientId Client ID from health config
         * @param {string} fallbackClientId Fallback client ID from health config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersConfigByClientIdsGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminPartnersConfigByClientIdsGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminPartnersConfigByClientIdsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves the full partner configuration including health config for the specified partner slug.
         * @summary Get partner configuration by slug
         * @param {string} slug Partner slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersConfigBySlugGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminPartnersConfigBySlugGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminPartnersConfigBySlugGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves the full partner configuration including health config for the specified partner ID.
         * @summary Get partner configuration by ID
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdConfigGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminPartnersPartnerIdConfigGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminPartnersPartnerIdConfigGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Issues an activation link, valid for 24 hours, for an eligibility record stored under `partner_id` that has no active sponsorship. A record whose sponsorship was removed can be issued a new link. When the record\'s client id or fallback client id matches a child partner of `partner_id`, the link names the child and carries `partner_id` as its parent partner; otherwise it names `partner_id` alone. Buy-up partners are refused: a buy-up child, or a partner with a pending upgrade transition. Requires write permission.
         * @summary Generate an activation link for an existing eligibility record
         * @param {string} partnerId The partner the eligibility record is stored under.
         * @param {string} memberId The eligibility record\&#39;s own id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Eligibility Search Admin API handler that fuzzy searches members on a partner\'s eligibility list.
         * @summary Eligibility Search Admin API handler
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminPartnersPartnerIdEligibilityMembersSearchGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the partner\'s sponsorship (group) configurations, each with its access code (sponsor code, derived from the group\'s segment match criteria). Used by the admin UI to let an operator pick a group when assigning a sponsorship; the chosen access code is sent as the sponsor_code field to the circle assign endpoint. Groups with no access code (default match-all sponsorships) return an empty accessCode.
         * @summary List a partner\'s sponsorship (group) configurations
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdSponsorshipsGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminPartnersPartnerIdSponsorshipsGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminPartnersPartnerIdSponsorshipsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRecipientRecipientIdGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminRecipientRecipientIdGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminRecipientRecipientIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves all keys from Redis cache and returns detailed timing statistics. Returns the list of keys, count, timing information, and response body size metrics for monitoring and debugging purposes.
         * @summary Retrieve all keys from Redis cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRedisKeysGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminRedisKeysGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminRedisKeysGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieves a value from Redis cache using the provided key and returns detailed timing statistics. Returns the value, timing information, and response body size metrics for monitoring and debugging purposes.
         * @summary Retrieve value from Redis cache by key
         * @param {string} key Redis key to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRedisKeysKeyGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminRedisKeysKeyGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminRedisKeysKeyGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Admin Remove Rewards removes rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Remove Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRemoveRewards(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminRemoveRewards(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminRemoveRewards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Returns user sponsor, dependents, and parents.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminUsersUserIdGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminUsersUserIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Returns timestamp when user active tokens got blocked.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminUsersUserIdTokensBlockedGet(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminUsersUserIdTokensBlockedGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Invalidates active access tokens of the user specified by user_id parameter.
         * @summary Blocks user active tokens
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedPost(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminUsersUserIdTokensBlockedPost(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1AdminUsersUserIdTokensBlockedPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Admin Recipient Rewards returns all rewards for a specific recipient including soft-deleted rewards.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Recipient Rewards (Admin Only)
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRecipientRewards(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetAdminRecipientRewards(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1GetAdminRecipientRewards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Admin Rewards returns a list of rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Rewards (Admin Only)
         * @param {Array<string>} [affiliatePartner] Partner IDs to filter rewards for
         * @param {boolean} [includeRedeemed] Include redeemed rewards in the response
         * @param {boolean} [includeDeleted] Include deleted rewards in the response
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRewards(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetAdminRewards(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1GetAdminRewards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Clinical Programs Access returns a complete access matrix showing all clinical programs and which lines of business (LOBs) have access to them. This endpoint provides both business-friendly LOB names (e.g., \"Optum\", \"E&I/UnitedHealth Group\") and technical partner ID details for debugging.  This is useful for understanding the full scope of workflow access across all LOBs and validating that partner restriction configurations are correct.  **Admin Access Required**: This endpoint requires admin permissions and is intended for internal use.  |Feature|Permission| |-------|----------| | access | admin |
         * @summary v1 Get Clinical Programs Access Matrix (Admin Only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetClinicalProgramsAccess(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetClinicalProgramsAccess(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1GetClinicalProgramsAccess']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Partner Child User Counts returns the number of distinct active users per child partner for a given parent partner. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Child User Counts (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerChildUserCounts(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetPartnerChildUserCounts(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1GetPartnerChildUserCounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Partner User Count returns the number of distinct users for a partner within a date range. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner User Count (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUserCount(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetPartnerUserCount(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1GetPartnerUserCount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Partner Users returns a paginated list of user accounts for a partner whose sponsorship_start_date falls within the given date range. Accounts are hydrated from the identity service. This endpoint is for internal admin use only.  Results are ordered by sponsorship `created_at DESC, user_id ASC` when `is_suspicious` is omitted (pagination driven by circle). When `is_suspicious` is supplied, the filter, pagination, and ordering are applied by identity over the full partner+date user_id set; ordering in that case is by account `created_at DESC, user_id ASC`.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Users (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {boolean} [isSuspicious] Optional filter on the &#x60;is_suspicious&#x60; flag. Omit to skip the filter; pass &#x60;true&#x60; to return only suspicious users; pass &#x60;false&#x60; to return only non-suspicious users.
         * @param {number} [limit] Max accounts to return per page. Defaults to 50, capped at 200.
         * @param {number} [offset] Number of accounts to skip. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUsers(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetPartnerUsers(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1GetPartnerUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Mark Partner Users Suspicious marks users for a partner whose sponsorship was created within a date range as suspicious or not suspicious. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Mark Partner Users Suspicious (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {CircleMarkPartnerUsersSuspiciousRequest} circleMarkPartnerUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MarkPartnerUsersSuspicious(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MarkPartnerUsersSuspicious(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1MarkPartnerUsersSuspicious']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Test Workflow Restrictions is an admin-only endpoint that simulates what workflows would be accessible for a theoretical recipient with the given partner and global classifier parameters. This endpoint is useful for testing and debugging partner workflow restrictions configuration changes.  The endpoint returns detailed information about which workflows are allowed or restricted, and why each restriction is applied, enabling administrators to validate configuration changes before deploying them.  **Admin Access Required**: This endpoint requires admin permissions and is intended for internal testing only.  |Feature|Permission| |-------|----------| | access | admin |
         * @summary v1 Test Workflow Restrictions (Admin Only)
         * @param {string} [partnerId] Partner ID to test restrictions for
         * @param {string} [parentPartnerId] Parent Partner ID to test restrictions for
         * @param {string} [sponsorshipId] Sponsorship ID to test restrictions for
         * @param {string} [globalClassifier] Global classifier to test restrictions for (e.g., us, gb, us_under_18)
         * @param {string} [workflowType] Filter results to specific workflow type (e.g., clinical_program, user_registration, survey)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TestWorkflowRestrictions(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1TestWorkflowRestrictions(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AdminApi.v1TestWorkflowRestrictions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 */
const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Free form user account lookup. Lookup by first, last name, email, phone number, or friends & family invitation code.
         * @param {string} [q] Search term for given name, family name, email, phone number, or friends &amp; family invitation code. It should have 3 or more characters to get result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAccountsGet(params, options) {
            return localVarFp
                .v1AdminAccountsGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Clears cached Databricks responses for the specified AI Router endpoint. This endpoint allows administrators to manually clear cached responses to ensure the next request fetches the most up-to-date data from Databricks.  Supported cache keys: - echo_back: Clears all cache entries with the pattern \"{databricks_echo_back}_*\" - content_filter: Clears all cache entries with the pattern \"{databricks_content_filter}_*\"
         * @summary Clears AI Router cached responses from Databricks.
         * @param {V1AdminCacheAiRouterCacheKeyDeleteCacheKeyEnum} cacheKey Cache key (echo_back or content_filter)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheAiRouterCacheKeyDelete(params, options) {
            return localVarFp
                .v1AdminCacheAiRouterCacheKeyDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Enumerates child partners of the given parent via the B2B service and invalidates every B2B cache entry (partner_pp, partner_slug_pp, partner_client_id_pp, sponsorship_pp, referral_pp, partner_health_resources_pp) belonging to those children. Intended for bulk flows like the CH EWS file ingestion process so callers don\'t have to issue a per-partner delete for every child.
         * @summary Clears B2B cache for every child partner of the given parent.
         * @param {string} parentPartnerId Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bParentsParentPartnerIdPartnersDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bParentsParentPartnerIdPartnersDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin API request handler.
         * @summary Deletes partner resources from cache for given identifiers.
         * @param {string} partnerId Partner ID
         * @param {string} [partnerSlug] Partner Slug
         * @param {string} [parentPartnerId] Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bPartnersPartnerIdDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {string} partnerId Partner ID
         * @param {string} [isDependentGroup] Is dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Clears data cached in the referrals key for the specified partner id and sponsorship id. Clears data for all supported languages.
         * @summary Clears cached referral data.
         * @param {string} partnerId Partner ID
         * @param {string} sponsorshipId Sponsorship ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Admin Create Rewards creates rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Create Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCreateRewards(params, options) {
            return localVarFp
                .v1AdminCreateRewards(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Admin Delete Recipient Reward deletes a specific reward for a recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Delete Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} rewardId The ID of the reward
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminDeleteRecipientReward(params, options) {
            return localVarFp
                .v1AdminDeleteRecipientReward(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns Calm Health partner configs
         * @param {V1AdminEligibilityPartnersGetIntegrationTypeEnum} [integrationType] Filter by integration type
         * @param {boolean} [active] Filter by active status (server default is true)
         * @param {string} [sort] Sort field (server default is \&quot;name\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminEligibilityPartnersGet(params, options) {
            return localVarFp
                .v1AdminEligibilityPartnersGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the full partner configuration by looking up a child partner using parent partner ID and client IDs.
         * @summary Get partner configuration by client IDs
         * @param {string} parentPartnerId Parent partner ID
         * @param {string} clientId Client ID from health config
         * @param {string} fallbackClientId Fallback client ID from health config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersConfigByClientIdsGet(params, options) {
            return localVarFp
                .v1AdminPartnersConfigByClientIdsGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the full partner configuration including health config for the specified partner slug.
         * @summary Get partner configuration by slug
         * @param {string} slug Partner slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersConfigBySlugGet(params, options) {
            return localVarFp
                .v1AdminPartnersConfigBySlugGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the full partner configuration including health config for the specified partner ID.
         * @summary Get partner configuration by ID
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdConfigGet(params, options) {
            return localVarFp
                .v1AdminPartnersPartnerIdConfigGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Issues an activation link, valid for 24 hours, for an eligibility record stored under `partner_id` that has no active sponsorship. A record whose sponsorship was removed can be issued a new link. When the record\'s client id or fallback client id matches a child partner of `partner_id`, the link names the child and carries `partner_id` as its parent partner; otherwise it names `partner_id` alone. Buy-up partners are refused: a buy-up child, or a partner with a pending upgrade transition. Requires write permission.
         * @summary Generate an activation link for an existing eligibility record
         * @param {string} partnerId The partner the eligibility record is stored under.
         * @param {string} memberId The eligibility record\&#39;s own id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost(params, options) {
            return localVarFp
                .v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Eligibility Search Admin API handler that fuzzy searches members on a partner\'s eligibility list.
         * @summary Eligibility Search Admin API handler
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options) {
            return localVarFp
                .v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns the partner\'s sponsorship (group) configurations, each with its access code (sponsor code, derived from the group\'s segment match criteria). Used by the admin UI to let an operator pick a group when assigning a sponsorship; the chosen access code is sent as the sponsor_code field to the circle assign endpoint. Groups with no access code (default match-all sponsorships) return an empty accessCode.
         * @summary List a partner\'s sponsorship (group) configurations
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdSponsorshipsGet(params, options) {
            return localVarFp
                .v1AdminPartnersPartnerIdSponsorshipsGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRecipientRecipientIdGet(params, options) {
            return localVarFp
                .v1AdminRecipientRecipientIdGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all keys from Redis cache and returns detailed timing statistics. Returns the list of keys, count, timing information, and response body size metrics for monitoring and debugging purposes.
         * @summary Retrieve all keys from Redis cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRedisKeysGet(params, options) {
            return localVarFp
                .v1AdminRedisKeysGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a value from Redis cache using the provided key and returns detailed timing statistics. Returns the value, timing information, and response body size metrics for monitoring and debugging purposes.
         * @summary Retrieve value from Redis cache by key
         * @param {string} key Redis key to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRedisKeysKeyGet(params, options) {
            return localVarFp
                .v1AdminRedisKeysKeyGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Admin Remove Rewards removes rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Remove Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRemoveRewards(params, options) {
            return localVarFp
                .v1AdminRemoveRewards(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns user sponsor, dependents, and parents.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdGet(params, options) {
            return localVarFp
                .v1AdminUsersUserIdGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns timestamp when user active tokens got blocked.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedGet(params, options) {
            return localVarFp
                .v1AdminUsersUserIdTokensBlockedGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Invalidates active access tokens of the user specified by user_id parameter.
         * @summary Blocks user active tokens
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedPost(params, options) {
            return localVarFp
                .v1AdminUsersUserIdTokensBlockedPost(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Admin Recipient Rewards returns all rewards for a specific recipient including soft-deleted rewards.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Recipient Rewards (Admin Only)
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRecipientRewards(params, options) {
            return localVarFp
                .v1GetAdminRecipientRewards(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Admin Rewards returns a list of rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Rewards (Admin Only)
         * @param {Array<string>} [affiliatePartner] Partner IDs to filter rewards for
         * @param {boolean} [includeRedeemed] Include redeemed rewards in the response
         * @param {boolean} [includeDeleted] Include deleted rewards in the response
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRewards(params, options) {
            return localVarFp
                .v1GetAdminRewards(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Clinical Programs Access returns a complete access matrix showing all clinical programs and which lines of business (LOBs) have access to them. This endpoint provides both business-friendly LOB names (e.g., \"Optum\", \"E&I/UnitedHealth Group\") and technical partner ID details for debugging.  This is useful for understanding the full scope of workflow access across all LOBs and validating that partner restriction configurations are correct.  **Admin Access Required**: This endpoint requires admin permissions and is intended for internal use.  |Feature|Permission| |-------|----------| | access | admin |
         * @summary v1 Get Clinical Programs Access Matrix (Admin Only)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetClinicalProgramsAccess(params, options) {
            return localVarFp
                .v1GetClinicalProgramsAccess(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Partner Child User Counts returns the number of distinct active users per child partner for a given parent partner. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Child User Counts (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerChildUserCounts(params, options) {
            return localVarFp
                .v1GetPartnerChildUserCounts(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Partner User Count returns the number of distinct users for a partner within a date range. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner User Count (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUserCount(params, options) {
            return localVarFp
                .v1GetPartnerUserCount(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Partner Users returns a paginated list of user accounts for a partner whose sponsorship_start_date falls within the given date range. Accounts are hydrated from the identity service. This endpoint is for internal admin use only.  Results are ordered by sponsorship `created_at DESC, user_id ASC` when `is_suspicious` is omitted (pagination driven by circle). When `is_suspicious` is supplied, the filter, pagination, and ordering are applied by identity over the full partner+date user_id set; ordering in that case is by account `created_at DESC, user_id ASC`.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Partner Users (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
         * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
         * @param {boolean} [isSuspicious] Optional filter on the &#x60;is_suspicious&#x60; flag. Omit to skip the filter; pass &#x60;true&#x60; to return only suspicious users; pass &#x60;false&#x60; to return only non-suspicious users.
         * @param {number} [limit] Max accounts to return per page. Defaults to 50, capped at 200.
         * @param {number} [offset] Number of accounts to skip. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetPartnerUsers(params, options) {
            return localVarFp
                .v1GetPartnerUsers(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Mark Partner Users Suspicious marks users for a partner whose sponsorship was created within a date range as suspicious or not suspicious. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Mark Partner Users Suspicious (Admin Only)
         * @param {string} partnerId The ID of the partner
         * @param {CircleMarkPartnerUsersSuspiciousRequest} circleMarkPartnerUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MarkPartnerUsersSuspicious(params, options) {
            return localVarFp
                .v1MarkPartnerUsersSuspicious(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Test Workflow Restrictions is an admin-only endpoint that simulates what workflows would be accessible for a theoretical recipient with the given partner and global classifier parameters. This endpoint is useful for testing and debugging partner workflow restrictions configuration changes.  The endpoint returns detailed information about which workflows are allowed or restricted, and why each restriction is applied, enabling administrators to validate configuration changes before deploying them.  **Admin Access Required**: This endpoint requires admin permissions and is intended for internal testing only.  |Feature|Permission| |-------|----------| | access | admin |
         * @summary v1 Test Workflow Restrictions (Admin Only)
         * @param {string} [partnerId] Partner ID to test restrictions for
         * @param {string} [parentPartnerId] Parent Partner ID to test restrictions for
         * @param {string} [sponsorshipId] Sponsorship ID to test restrictions for
         * @param {string} [globalClassifier] Global classifier to test restrictions for (e.g., us, gb, us_under_18)
         * @param {string} [workflowType] Filter results to specific workflow type (e.g., clinical_program, user_registration, survey)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TestWorkflowRestrictions(params, options) {
            return localVarFp
                .v1TestWorkflowRestrictions(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 */
class AdminApi extends base_1.BaseAPI {
    /**
     * URL `/v1/admin/accounts`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Free form user account lookup. Lookup by first, last name, email, phone number, or friends & family invitation code.
     * @param {string} [q] Search term for given name, family name, email, phone number, or friends &amp; family invitation code. It should have 3 or more characters to get result.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminAccountsGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminAccountsGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/ai-router/{cache_key}`
     * Clears cached Databricks responses for the specified AI Router endpoint. This endpoint allows administrators to manually clear cached responses to ensure the next request fetches the most up-to-date data from Databricks.  Supported cache keys: - echo_back: Clears all cache entries with the pattern \"{databricks_echo_back}_*\" - content_filter: Clears all cache entries with the pattern \"{databricks_content_filter}_*\"
     * @summary Clears AI Router cached responses from Databricks.
     * @param {V1AdminCacheAiRouterCacheKeyDeleteCacheKeyEnum} cacheKey Cache key (echo_back or content_filter)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminCacheAiRouterCacheKeyDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheAiRouterCacheKeyDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b`
     * Admin API request handler.
     * @summary Admin API handler
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminCacheB2bDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b/parents/{parent_partner_id}/partners`
     * Enumerates child partners of the given parent via the B2B service and invalidates every B2B cache entry (partner_pp, partner_slug_pp, partner_client_id_pp, sponsorship_pp, referral_pp, partner_health_resources_pp) belonging to those children. Intended for bulk flows like the CH EWS file ingestion process so callers don\'t have to issue a per-partner delete for every child.
     * @summary Clears B2B cache for every child partner of the given parent.
     * @param {string} parentPartnerId Parent Partner ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminCacheB2bParentsParentPartnerIdPartnersDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bParentsParentPartnerIdPartnersDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b/partners/{partner_id}`
     * Admin API request handler.
     * @summary Deletes partner resources from cache for given identifiers.
     * @param {string} partnerId Partner ID
     * @param {string} [partnerSlug] Partner Slug
     * @param {string} [parentPartnerId] Parent Partner ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminCacheB2bPartnersPartnerIdDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bPartnersPartnerIdDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships`
     * Admin API request handler.
     * @summary Admin API handler
     * @param {string} partnerId Partner ID
     * @param {string} [isDependentGroup] Is dependent group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships/{sponsorship_id}/referrals`
     * Clears data cached in the referrals key for the specified partner id and sponsorship id. Clears data for all supported languages.
     * @summary Clears cached referral data.
     * @param {string} partnerId Partner ID
     * @param {string} sponsorshipId Sponsorship ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/rewards`
     * v1 Admin Create Rewards creates rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Admin Create Rewards (Admin Only)
     * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminCreateRewards(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCreateRewards(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/recipients/{recipient_id}/rewards/{reward_id}`
     * v1 Admin Delete Recipient Reward deletes a specific reward for a recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Admin Delete Recipient Reward
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} rewardId The ID of the reward
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminDeleteRecipientReward(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminDeleteRecipientReward(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/eligibility-partners`
     *
     * @summary Returns Calm Health partner configs
     * @param {V1AdminEligibilityPartnersGetIntegrationTypeEnum} [integrationType] Filter by integration type
     * @param {boolean} [active] Filter by active status (server default is true)
     * @param {string} [sort] Sort field (server default is \&quot;name\&quot;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminEligibilityPartnersGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminEligibilityPartnersGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/partners/config/by-client-ids`
     * Retrieves the full partner configuration by looking up a child partner using parent partner ID and client IDs.
     * @summary Get partner configuration by client IDs
     * @param {string} parentPartnerId Parent partner ID
     * @param {string} clientId Client ID from health config
     * @param {string} fallbackClientId Fallback client ID from health config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminPartnersConfigByClientIdsGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminPartnersConfigByClientIdsGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/partners/config/by-slug`
     * Retrieves the full partner configuration including health config for the specified partner slug.
     * @summary Get partner configuration by slug
     * @param {string} slug Partner slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminPartnersConfigBySlugGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminPartnersConfigBySlugGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/partners/{partner_id}/config`
     * Retrieves the full partner configuration including health config for the specified partner ID.
     * @summary Get partner configuration by ID
     * @param {string} partnerId The ID of the partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminPartnersPartnerIdConfigGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminPartnersPartnerIdConfigGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/partners/{partner_id}/eligibility/members/{member_id}/activation-link`
     * Issues an activation link, valid for 24 hours, for an eligibility record stored under `partner_id` that has no active sponsorship. A record whose sponsorship was removed can be issued a new link. When the record\'s client id or fallback client id matches a child partner of `partner_id`, the link names the child and carries `partner_id` as its parent partner; otherwise it names `partner_id` alone. Buy-up partners are refused: a buy-up child, or a partner with a pending upgrade transition. Requires write permission.
     * @summary Generate an activation link for an existing eligibility record
     * @param {string} partnerId The partner the eligibility record is stored under.
     * @param {string} memberId The eligibility record\&#39;s own id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminPartnersPartnerIdEligibilityMembersMemberIdActivationLinkPost(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/partners/{partner_id}/eligibility/members/search`
     * Eligibility Search Admin API handler that fuzzy searches members on a partner\'s eligibility list.
     * @summary Eligibility Search Admin API handler
     * @param {string} partnerId The ID of the partner
     * @param {string} [memberId] Id of the member to search
     * @param {string} [email] Email of the member to search
     * @param {string} [firstName] First name of the member to search
     * @param {string} [lastName] Last name of the member to search
     * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
     * @param {string} [subscriberId] SubscriberId of the member to search.
     * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/partners/{partner_id}/sponsorships`
     * Returns the partner\'s sponsorship (group) configurations, each with its access code (sponsor code, derived from the group\'s segment match criteria). Used by the admin UI to let an operator pick a group when assigning a sponsorship; the chosen access code is sent as the sponsor_code field to the circle assign endpoint. Groups with no access code (default match-all sponsorships) return an empty accessCode.
     * @summary List a partner\'s sponsorship (group) configurations
     * @param {string} partnerId The ID of the partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminPartnersPartnerIdSponsorshipsGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminPartnersPartnerIdSponsorshipsGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/recipient/{recipient_id}`
     * Admin API request handler.
     * @summary Admin API handler
     * @param {number} recipientId Recipient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminRecipientRecipientIdGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminRecipientRecipientIdGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/redis/keys`
     * Retrieves all keys from Redis cache and returns detailed timing statistics. Returns the list of keys, count, timing information, and response body size metrics for monitoring and debugging purposes.
     * @summary Retrieve all keys from Redis cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminRedisKeysGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminRedisKeysGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/redis/keys/{key}`
     * Retrieves a value from Redis cache using the provided key and returns detailed timing statistics. Returns the value, timing information, and response body size metrics for monitoring and debugging purposes.
     * @summary Retrieve value from Redis cache by key
     * @param {string} key Redis key to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminRedisKeysKeyGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminRedisKeysKeyGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/rewards`
     * v1 Admin Remove Rewards removes rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Admin Remove Rewards (Admin Only)
     * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminRemoveRewards(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminRemoveRewards(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/users/{user_id}`
     *
     * @summary Returns user sponsor, dependents, and parents.
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminUsersUserIdGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminUsersUserIdGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/users/{user_id}/tokens/blocked`
     *
     * @summary Returns timestamp when user active tokens got blocked.
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminUsersUserIdTokensBlockedGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminUsersUserIdTokensBlockedGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/users/{user_id}/tokens/blocked`
     * Invalidates active access tokens of the user specified by user_id parameter.
     * @summary Blocks user active tokens
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminUsersUserIdTokensBlockedPost(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminUsersUserIdTokensBlockedPost(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/recipients/{recipient_id}/rewards`
     * v1 Get Admin Recipient Rewards returns all rewards for a specific recipient including soft-deleted rewards.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Admin Recipient Rewards (Admin Only)
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} [limit] Limit for pagination
     * @param {number} [offset] Offset for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetAdminRecipientRewards(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1GetAdminRecipientRewards(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/rewards`
     * v1 Get Admin Rewards returns a list of rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Admin Rewards (Admin Only)
     * @param {Array<string>} [affiliatePartner] Partner IDs to filter rewards for
     * @param {boolean} [includeRedeemed] Include redeemed rewards in the response
     * @param {boolean} [includeDeleted] Include deleted rewards in the response
     * @param {number} [limit] Limit for pagination
     * @param {number} [offset] Offset for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetAdminRewards(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1GetAdminRewards(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/admin/clinical-programs-access`
     * v1 Get Clinical Programs Access returns a complete access matrix showing all clinical programs and which lines of business (LOBs) have access to them. This endpoint provides both business-friendly LOB names (e.g., \"Optum\", \"E&I/UnitedHealth Group\") and technical partner ID details for debugging.  This is useful for understanding the full scope of workflow access across all LOBs and validating that partner restriction configurations are correct.  **Admin Access Required**: This endpoint requires admin permissions and is intended for internal use.  |Feature|Permission| |-------|----------| | access | admin |
     * @summary v1 Get Clinical Programs Access Matrix (Admin Only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetClinicalProgramsAccess(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1GetClinicalProgramsAccess(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/children/users/count`
     * v1 Get Partner Child User Counts returns the number of distinct active users per child partner for a given parent partner. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Partner Child User Counts (Admin Only)
     * @param {string} partnerId The ID of the partner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetPartnerChildUserCounts(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1GetPartnerChildUserCounts(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/users/count`
     * v1 Get Partner User Count returns the number of distinct users for a partner within a date range. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Partner User Count (Admin Only)
     * @param {string} partnerId The ID of the partner
     * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
     * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetPartnerUserCount(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1GetPartnerUserCount(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/users`
     * v1 Get Partner Users returns a paginated list of user accounts for a partner whose sponsorship_start_date falls within the given date range. Accounts are hydrated from the identity service. This endpoint is for internal admin use only.  Results are ordered by sponsorship `created_at DESC, user_id ASC` when `is_suspicious` is omitted (pagination driven by circle). When `is_suspicious` is supplied, the filter, pagination, and ordering are applied by identity over the full partner+date user_id set; ordering in that case is by account `created_at DESC, user_id ASC`.  **Admin Access Required**: This endpoint requires admin read permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Partner Users (Admin Only)
     * @param {string} partnerId The ID of the partner
     * @param {string} startDate Start of the date range (RFC3339 format, e.g. 2024-01-01T00:00:00Z)
     * @param {string} endDate End of the date range (RFC3339 format, e.g. 2024-12-31T23:59:59Z)
     * @param {boolean} [isSuspicious] Optional filter on the &#x60;is_suspicious&#x60; flag. Omit to skip the filter; pass &#x60;true&#x60; to return only suspicious users; pass &#x60;false&#x60; to return only non-suspicious users.
     * @param {number} [limit] Max accounts to return per page. Defaults to 50, capped at 200.
     * @param {number} [offset] Number of accounts to skip. Defaults to 0.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetPartnerUsers(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1GetPartnerUsers(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/partners/{partner_id}/users/suspicious`
     * v1 Mark Partner Users Suspicious marks users for a partner whose sponsorship was created within a date range as suspicious or not suspicious. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin write permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Mark Partner Users Suspicious (Admin Only)
     * @param {string} partnerId The ID of the partner
     * @param {CircleMarkPartnerUsersSuspiciousRequest} circleMarkPartnerUsersSuspiciousRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1MarkPartnerUsersSuspicious(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1MarkPartnerUsersSuspicious(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/workflows/admin/test-restrictions`
     * v1 Test Workflow Restrictions is an admin-only endpoint that simulates what workflows would be accessible for a theoretical recipient with the given partner and global classifier parameters. This endpoint is useful for testing and debugging partner workflow restrictions configuration changes.  The endpoint returns detailed information about which workflows are allowed or restricted, and why each restriction is applied, enabling administrators to validate configuration changes before deploying them.  **Admin Access Required**: This endpoint requires admin permissions and is intended for internal testing only.  |Feature|Permission| |-------|----------| | access | admin |
     * @summary v1 Test Workflow Restrictions (Admin Only)
     * @param {string} [partnerId] Partner ID to test restrictions for
     * @param {string} [parentPartnerId] Parent Partner ID to test restrictions for
     * @param {string} [sponsorshipId] Sponsorship ID to test restrictions for
     * @param {string} [globalClassifier] Global classifier to test restrictions for (e.g., us, gb, us_under_18)
     * @param {string} [workflowType] Filter results to specific workflow type (e.g., clinical_program, user_registration, survey)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1TestWorkflowRestrictions(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1TestWorkflowRestrictions(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
exports.V1AdminCacheAiRouterCacheKeyDeleteCacheKeyEnum = {
    EchoBack: 'echo_back',
    ContentFilter: 'content_filter',
};
exports.V1AdminEligibilityPartnersGetIntegrationTypeEnum = {
    EligibilityFile: 'ELIGIBILITY_FILE',
    GroupCode: 'GROUP_CODE',
};
//# sourceMappingURL=admin-api.js.map